import { IMapContentState } from "./interfaces";

export const DEFAULT_MAP_CONT_STATE: IMapContentState = {
	changeId: 0,
	affectedType: "marker",
	affectedMarkerIds: [],
	affectedGeometryIds: [],
	markers: [],
	geometries: [],
};
